import type { FrameRangeT } from '../../common/types/types';
export const formatFrameRange = (frameRange: FrameRangeT): string => {
  if (!frameRange) return '';
  const {
    startFrameIndex,
    endFrameIndex
  } = frameRange;
  if (startFrameIndex === endFrameIndex) {
    return `${startFrameIndex + 1}`;
  }
  return `${startFrameIndex + 1} → ${endFrameIndex + 1}`;
};
export const getCompositeRelationshipLabelName = (relationshipLabelName: string, sourceAnnotationLabel: string, targetAnnotationLabel: string) => {
  return `${relationshipLabelName}::${sourceAnnotationLabel}::${targetAnnotationLabel}`;
};